import React from 'react';
import { PendingPayablesSummary as PendingPayablesSummaryType } from './summarize';

interface Props {
  summary: PendingPayablesSummaryType;
}

const fmtMoney = (n: number): string =>
  `$${n.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;

export const PendingPayablesSummary: React.FC<Props> = ({ summary }) => {
  return (
    <div className="flex w-full flex-col gap-2 rounded-lg border-l-4 border-primary-300 bg-white p-4 shadow-analyticsCard">
      <div className="flex flex-wrap items-baseline gap-3">
        <span className="text-12s uppercase tracking-wide text-gray-500">Pending payables</span>
        <span className="text-24s font-bold text-gray-900">{summary.count}</span>
        <span className="text-18s text-gray-700">{fmtMoney(summary.total_amount)}</span>
      </div>
    </div>
  );
};

export default PendingPayablesSummary;
